
import BaseFilter from '@/components/filters/Filter';

export default BaseFilter.extend({
	props: {
		value: {
			type: Object as () => {
				low: string,
				high: string
			},
			required: true,
			default: () => ({
				high: '',
				low: ''
			})
		}
	},
});

